import type {Ng2StateDeclaration} from '@uirouter/angular';
import {WORK_TIME_CONTROLLING_KINDERORT_STATE} from './work-time-controlling-kinderort.states';

export const WORK_TIME_CONTROLLING_KINDERORT_FEATURE = {
    name: `${WORK_TIME_CONTROLLING_KINDERORT_STATE.name}.**`,
    url: WORK_TIME_CONTROLLING_KINDERORT_STATE.url,
    loadChildren: () =>
        import('./work-time-controlling-kinderort.module').then(m => m.WorkTimeControllingKinderortModule),
} satisfies Ng2StateDeclaration;
